<template>
  <div class="connector-indicator-card">
    <img
      v-if="item.icon"
      :src="item.icon"
      class="connector-indicator-icon"
      alt=""
    />
    <component :is="fallbackIcon" v-else class="connector-indicator-icon" />
    <!-- <div class="connector-indicator-title">
      {{ item.label }}
    </div> -->
    <div class="connector-indicator-info">
      <div class="connector-indicator-label">
        Выручка
      </div>
      <span class="connector-indicator-revenue">{{
        item.revenue | amountWithCurrency0
      }}</span>
    </div>
    <div class="connector-indicator-info">
      <div class="connector-indicator-label">
        Заказы
      </div>
      <div class="connector-indicator-count">
        {{ item.ordersCount }}
      </div>
    </div>
    <div class="connector-indicator-name">
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
  import IconYandex from '@/components/administrator/cashier/icons/IconYandex.vue'
  import BasketSource from '@/models/enums/BasketSource'
  import IconDelivery from '@/components/administrator/cashier/icons/IconDelivery.vue'
  import IconChibis from '@/components/administrator/cashier/icons/IconChibis.vue'
  import AggregatorsBrand from '@/models/enums/AggregatorsBrand'
  import IconSetDelivery from '@/components/administrator/cashier/icons/IconSetDelivery.vue'
  import IconKuper from '@/components/administrator/cashier/icons/IconKuper.vue'
  import IconWellFedElephant from '@/components/administrator/cashier/icons/IconWellFedElephant.vue'

  export default {
    name: 'ConnectorIndicatorCard',
    components: { IconYandex },
    props: {
      item: Object,
    },
    computed: {
      fallbackIcon () {
        switch (this.item.aggregator) {
          case BasketSource.Yandex:
            return IconYandex
          case BasketSource.DeliveryClub:
            return IconDelivery
          case BasketSource.SberMarket:
            return IconKuper
          case BasketSource.Chibis:
            return IconChibis
          case AggregatorsBrand.SetDelivery:
            return IconSetDelivery
          case AggregatorsBrand.WellFedElephant:
            return IconWellFedElephant
          default:
            return null
        }
      },
    },
  }
</script>

<style scoped lang="less">
.connector-indicator {
  &-card {
    position: relative;
    box-sizing: border-box;
    height: 150px;
    padding: 10px 14px;
    background-color: #eff0f4;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &-title,
  &-label,
  &-revenue,
  &-count,
  &-name {
    position: relative;
    z-index: 2;
  }

  &-title {
    padding-right: 76px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-info {
    margin-bottom: 2px;
  }

  &-icon {
    position: absolute;
    right: 12px;
    top: 12px;
    z-index: 1;
    width: 84px;
    height: 84px;
  }

  &-label {
    font-size: 13px;
  }

  &-revenue,
  &-count {
    font-size: 18px;
    font-weight: bold;
  }

  &-name {
    margin-top: auto;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0.4px;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
